import FJClose from '../../../common/components/FJClose/FJClose';
import styles from './FJModalClose.module.less';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function FJModalClose(props) {
    let { onClick } = props;
    return (
        <div className={classNames(styles.close, props.className)} onClick={onClick}>
            <FJClose />
        </div>
    );
}
FJModalClose.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
};
export default FJModalClose;
